<template>
	<div class="otherInfo py-[20px] box-border">
		<div class="flex items-start mb-[20px]">
			<label class="cursor-pointer flex  align-top  mr-[12px] text-[#A6A6A6]" @click="backIndex()">
				<i class="el-icon-arrow-left mr-[10px] text-[20px] font-bold "></i>
				返回
			</label>

			<label class="mr-[12px] text-[#A6A6A6]">|</label>
			<label @click="get_notice_detail(noticeDetail.prev_id)"
				class="mr-[12px] text-[#A6A6A6] cursor-pointer">上一封</label>
			<label @click="get_notice_detail(noticeDetail.next_id)" class=" text-[#A6A6A6] cursor-pointer">下一封</label>
		</div>
		<div class="py-[20px] box-border title">
			<div class="text-[20px] font-bold text-center mb-[10px]">
				{{noticeDetail.title}}
			</div>
			<div class="text-[14px] text-[#A6A6A6]  text-center ">
				{{noticeDetail.create_time}}
			</div>
		</div>

		<div class="py-[20px] box-border">
			<div v-html="noticeDetail.textarea" class="whitespace-pre-wrap mb-[20px]">
			</div>
			<!-- <div class=" text-[#FF0000] font-bold text-[18px] mb-[6px]">
				已通过审核
			</div>
			<div class=" text-[16px]">
				理由: <label class="text-[#FF0000] italic text-[16px]">数字不长考,如果记不住请忽略</label>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {

		data() {
			return {
				id: '',
				htmlStr: "内容11111111111",
				noticeDetail: {
					title: "",
					create_time: '',
					textarea: '',
					prev_id: 0, //上一封id
					related_id: 0, //下一封id
				}
			}
		},
		watch: {
			'$route'(to, from) {
				// 当路由变化时，这里的to和from包含了路由信息
				console.log("to======");
				console.log(to); // 获取查询参数
				if (to.query.id) {
					this.id = to.query.id
					this.get_notice_detail(this.id)
				}
			}
		},
		mounted() {
			console.log("this.$route=====");
			console.log(this.$route);
			this.id = this.$route.query.id
			this.get_notice_detail(this.id)
		},
		methods: {
			get_notice_detail(id) {
				console.log("id===" + id);
				if (!id) {
					this.$message({
						message: "通知不存在",
						type: 'warning'
					})
					return
				}
				this.$api.getNoticeDetail({
					id: id
				}).then((res) => {
					console.log(res);
					this.noticeDetail = res.data

				}).catch((error) => {
					this.isFinish = true
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			backIndex() {
				this.$router.go(-1)
			},


		}
	}
</script>

<style scoped>
	.title {
		border-bottom: 1px solid #dddddd;
	}
</style>